"use client";

import Page from "@/components/Page";
import Section from "@/components/ui/Section";
import { TinaMarkdown, tinaField, useTina } from "@/lib/utils";

export default function PageClient(props) {
  const { data } = useTina({
    query: props.query,
    variables: props.variables,
    data: props.data,
  });

  const { title, body } = data.legal;

  return (
    <Page defaultTinaField={data.legal}>
      <Section as="article">
        <div className="mx-auto max-w-3xl">
          <h1 data-tina-field={tinaField(data.legal, "title")} className="h1 mb-8 md:mb-12">
            {title}
          </h1>
          <div data-tina-field={tinaField(data.legal, "body")} className="prose prose-lg max-w-none">
            <TinaMarkdown content={body} />
          </div>
        </div>
      </Section>
    </Page>
  );
}
